import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/solutions/gateway-to-europe")({
  head: () => buildRouteHead("/es/solutions/gateway-to-europe", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/soluciones/gateway-to-europe", replace: true });
  },
});
